import { useRef } from "react";
import SimpleReactValidator from "simple-react-validator";

const useSimpleValidator = () => {
    const simpleValidator = useRef( new SimpleReactValidator({
        element: false,
        autoForceUpdate:this,
        messages: {
            email: 'Kentän on oltava voimassa oleva sähköpostiosoite',
            phone: 'Kentän on oltava voimassa oleva puhelinnumero',
            required: 'Kenttä on pakollinen',
            accepted: 'Hyväksy ehdot',
        },

        validators: {
            phone2: {
                message: 'Puhelinnumeron pitää olla seuraavassa muodossa: +358401234567',
                // @ts-ignore for some reason the validator isn't included in the interface
                rule: (val:any, params:any, validator:any ): boolean => {
                    return validator.helpers.testRegex( val.replace(' ', ''), /^\+[1-9]{1}[0-9]{3,14}$/ ); 
                }
            }
        }
    }));

    return simpleValidator;
}

export default useSimpleValidator;